<template>
  <div id="app">
    <!-- Only renders when the device is online -->
    <!-- <div v-if="connectionStatus" id="on-indicator" slot="online">
      <p>It looks like you're online!</p>
    </div> -->
    <!-- Only renders when the device is offline -->
    <div v-if="!connectionStatus" id="off-indicator" slot="offline">
      <p>You appear to be offline, please connect to any internet connection...</p>
    </div>
    <Header/>
    <div class="divider mobile-small-hide"></div>
    <div class="divider divider--margin-small mobile-small-show"></div>
    <vue-page-transition name="fade-in-right">
      <router-view/>
    </vue-page-transition>
  </div>
</template>


<style lang="scss">
  @import '@/scss/settings.scss';
  @import '@/scss/base.scss';
</style>
<style>
* {
  cursor: none;
}
</style>
<script>
import Header from '@/components/Header.vue'
export default {
  data() {
    return {
      connectionStatus: ''
    }
  },
  components: {
    Header
  },
  metaInfo: {
    title: 'Loading...',
    titleTemplate: '%s | BNI Service Rating'
  },
  mounted() {
    if(navigator.onLine) {
      this.connectionStatus = true
    } else {
      this.connectionStatus = false
    }
  }
}
</script>

<style>
/* * {
  cursor: none;
} */
#on-indicator {
	position: fixed;
	left: 0;
	right: 0;
	top: 2.5;

	z-index: 1051;
	width: 30%;
	margin: 0 auto;

	padding: .5em;
  color: #fff;
  text-align: center;
	background-color: rgb(29, 199, 105);
	box-shadow: 0px -3px 10px rgba(black, 0.75);

	border-radius: 10px;
}
#off-indicator {
	position: fixed;
	left: 0;
	right: 0;
	top: 0.25;

	z-index: 1051;
	width: 28%;
	margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
	padding: .5em;
  color: #fff;
  text-align: center;
	background-color: rgba(199, 20, 20, 0.65);
	box-shadow: 0px -3px 10px rgba(black, 0.75);

	border-radius: 10px;
}
#keyboard {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;

	z-index: 1051;
	width: 100%;
	margin: 0 auto;

	padding: 1em;

	background-color: #3C4858;
	box-shadow: 0px -3px 10px rgba(black, 0.3);

	border-radius: 10px;
}
</style>


